import React,{useState}  from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import '../App.css';
import Switch from 'react-switch';
import { FaMoon, FaSun } from 'react-icons/fa';


function NavBar() {
  const [switchOn, setSwitchOn] = useState(false);
  const handleSwitchChange = () => {
    setSwitchOn(!switchOn);
    if(switchOn){
      document.documentElement.style.setProperty('--cor-primaria', '#000');
      document.documentElement.style.setProperty('--cor-secundaria', '#ffffff');
    }else{
      document.documentElement.style.setProperty('--cor-secundaria', '#000');
      document.documentElement.style.setProperty('--cor-primaria', '#ffffff');
    }
  };
  
  return(
    <Navbar fixed="top" style={{"background":"rgba(255, 255, 255, 0.46)"}} expand="lg">
      <Container fluid>
        <Navbar.Brand href="#">
          Jefferson Maxwell
          <span> </span>
          {
            <Switch type="checkbox"   
            checkedIcon={
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}>
                <FaSun size={15} color="#000" />
              </div>
            }
            uncheckedIcon={
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}>
                <FaMoon size={15} color="#000" />
              </div>

            } 
            onColor='#E20000'
            onChange={handleSwitchChange} checked={switchOn} />

          }
          

        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse className="justify-content-end" id="navbarScroll">
          <Nav>
            
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#skills">Habilidades</Nav.Link>
            <Nav.Link href="#projetos">Projetos</Nav.Link>
            <Nav.Link href="#contato">Contato</Nav.Link>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
export default NavBar;